import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { Offer } from "@/components/Offer";
import { Benefits } from "@/components/Benefits";
import { WhyUs } from "@/components/WhyUs";
import { FormsOfComedy } from "@/components/FormsOfComedy";
import { Testimonials } from "@/components/Testimonials";
import { ContactForm } from "@/components/ContactForm";
import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";
import { VideoSection } from "@/components/VideoSection";
import { Separator } from "@/components/Separator";
import { StatsCounter } from "@/components/StatsCounter";
import { Helmet } from "react-helmet-async";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>WystepyFirmowe.pl - Atrakcje eventowe dla biznesu</title>
        <meta name="description" content="Kompleksowa oprawa artystyczna eventów firmowych. Ponad 80 atrakcji: stand-up, kabaret, muzyka, pokazy taneczne, iluzja i więcej. Cała Polska." />
        <link rel="canonical" href="https://wystepyfirmowe.pl/" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="WystepyFirmowe.pl - Atrakcje eventowe dla biznesu" />
        <meta property="og:description" content="Kompleksowa oprawa artystyczna eventów firmowych. Ponad 80 atrakcji w całej Polsce." />
        <meta property="og:url" content="https://wystepyfirmowe.pl/" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="pl_PL" />
      </Helmet>
      <Navigation />
      <Hero />
      <StatsCounter />
      <Separator />
      <About />
      <Separator />
      <Offer />
      <Separator />
      <Benefits />
      <Separator />
      <WhyUs />
      <Separator />
      <FormsOfComedy />
      <Separator />
      <VideoSection />
      <Separator />
      <Testimonials />
      <Separator />
      <ContactForm />
      <Footer />
    </div>
  );
};

export default Index;
